module.exports = __webpack_public_path__ + "img/step-3.a37ee3ff.png";